function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import ViewMore from '../view-more';
import Inspection from './inspection';
import Popup from './casual-limit-popup';
import * as styles from './open-times.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OpenTimes = _ref => {
  var listing = _ref.listing,
    inspections = _ref.inspections,
    onRemoveFromPlanner = _ref.onRemoveFromPlanner,
    onCalendarDownload = _ref.onCalendarDownload,
    onSignUpClick = _ref.onSignUpClick,
    onLogInClick = _ref.onLogInClick,
    onExpandToggle = _ref.onExpandToggle,
    openSignUp = _ref.openSignUp,
    openSignIn = _ref.openSignIn;
  var popupContainer = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    popup = _useState2[0],
    setPopup = _useState2[1];
  if (!(inspections !== null && inspections !== void 0 && inspections.length)) {
    return ___EmotionJSX("p", {
      css: styles.noInspections
    }, "No inspections scheduled on Allhomes, yet. You may ask the agent about upcoming inspections.");
  }
  var onSignUp = () => {
    openSignUp();
    onSignUpClick();
  };
  var onLogIn = () => {
    openSignIn();
    onLogInClick();
  };
  var openMaxAllowedPopup = _ref2 => {
    var maxAllowed = _ref2.maxAllowed,
      buttonRef = _ref2.buttonRef;
    var buttonPosition = buttonRef.getBoundingClientRect();
    var containerPosition = popupContainer.current.getBoundingClientRect();
    setPopup({
      maxAllowed,
      top: buttonPosition.y - containerPosition.y,
      left: buttonPosition.x - containerPosition.x,
      onSignUp,
      onLogIn
    });
  };
  var onPopupClose = () => {
    setPopup(null);
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    ref: popupContainer,
    css: styles.popupContainerOuter
  }, popup && ___EmotionJSX("div", {
    css: styles.popupContainerInner(popup)
  }, ___EmotionJSX(Popup, {
    onClose: onPopupClose,
    onSignUp: popup.onSignUp,
    onSignIn: popup.onLogIn,
    maxAllowed: popup.maxAllowed
  }))), ___EmotionJSX(ViewMore, {
    css: styles.inspections,
    expandedHeight: 252,
    onExpandToggle: onExpandToggle
  }, _ref3 => {
    var expanded = _ref3.expanded;
    return inspections.map((event, index) => ___EmotionJSX(Inspection, _extends({
      key: event.startTime,
      position: index + 1,
      listing: listing
    }, event, {
      onSignUpClick: onSignUpClick,
      onLogInClick: onLogInClick,
      onRemoveFromPlanner: onRemoveFromPlanner,
      onCalendarDownload: onCalendarDownload,
      expanded: expanded,
      openMaxAllowedPopup: openMaxAllowedPopup
    })));
  }));
};
OpenTimes.propTypes = {
  listing: PropTypes.shape({}).isRequired,
  inspections: PropTypes.arrayOf(PropTypes.shape({})),
  onExpandToggle: PropTypes.func,
  onRemoveFromPlanner: PropTypes.func,
  onCalendarDownload: PropTypes.func,
  openSignUp: PropTypes.func,
  openSignIn: PropTypes.func,
  onSignUpClick: PropTypes.func,
  onLogInClick: PropTypes.func
};
OpenTimes.defaultProps = {
  inspections: [],
  onExpandToggle: () => {},
  onRemoveFromPlanner: () => {},
  onCalendarDownload: () => {},
  openSignUp: () => {},
  openSignIn: () => {},
  onSignUpClick: () => {},
  onLogInClick: () => {}
};
export default withAllhomesContext('openSignUp', 'openSignIn')(OpenTimes);